export function bytesToMB(bytes, decimals = 2) {
    if (!bytes || bytes <= 0) return '0 MB';
    const mb = bytes / (1024 * 1024);
    return mb.toFixed(decimals) + ' MB';
  }

  export function getProgressPercent(usedBytes, total, format = 'MB') {
    if (!usedBytes || !total || total === 0) return 0;
  
    const formatToBytes = {
      KB: 1024,
      MB: 1024 * 1024,
      GB: 1024 * 1024 * 1024,
    };
  
    const totalBytes = total * (formatToBytes[format.toUpperCase()] || formatToBytes['MB']);
    return Math.min((usedBytes / totalBytes) * 100, 100);
  }